@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in">
      <div class="flex flex-row items-center ml-4 gap-4">
        <div class="leading-6 font-large text-lg">{{ field.label | localize }}</div>
      </div>
      <div class="flex flex-col justify-between mb-2 mt-4 px-2">
        <!-- Header -->
            <div class="grid table-grid z-10 text-sm top-0 grid gap-4 py-4 px-4 sm:px-6 shadow text-md font-semibold text-secondary
                        bg-gray-50 dark:bg-slate-900">
          <div class="flex items-center">
            {{ $safeNavigationMigration(field?.firstColumnHeader) | localize }}
          </div>
          <div class="flex items-center">
            {{ $safeNavigationMigration(field?.secondColumnHeader) | localize }}
          </div>
        </div>
        <!-- Rows -->
        @for (value of tableData; track value; let i = $index) {
          <div class="grid table-grid items-center gap-4 py-3 px-4 sm:px-6 border-b">
            <div class="flex items-center">
              {{ getValueToPrint(value) }}
            </div>
            @if (numberControl) {
              <div  class="flex items-center">
                <mat-form-field class="w-full">
                  <input matInput type="number" [formControl]="getControl(i)"
                    [readonly]="field.readonly" [required]="field.required"/>
                  </mat-form-field>
                </div>
              }
            </div>
          }
          <!-- Total -->
          @if (field.displayTotals) {
            <div class="grid table-grid items-center gap-4 py-3 px-4 sm:px-6 border-b">
              <div class="flex items-center">
                {{ 'TOTAL' | transloco }}
              </div>
              <div class="flex items-center">
                {{ total }}
              </div>
            </div>
          }
        </div>
      </div>
    }
  }